<div class="modal" role="dialog" aria-modal="true" [attr.aria-label]="title">
  <div class="modal__contents" #modalContents>
    <iframe [src]="url" class="modal__frame" cdkFocusInitial> </iframe>
  </div>

  <button
    app-button
    buttonTheme="dark"
    buttonType="white"
    buttonShape="circle"
    type="button"
    (click)="closeDialog()"
    title="Close"
    [attr.aria-label]="'Close'"
    class="modal__close">
    <app-icon icon="times" size="lg"> </app-icon>
  </button>
</div>
